/**
 * Reviews module
 *
 * Module index file
 *
 * This file is used by theme to provide default functionality
 * to the module and to register all components.
 *
 * This file has to export setup function that will be called
 * automatically by import in the theme app.ts file.
 */

import { App } from 'vue';

import ReviewsBlock from '@src/Reviews/Pages/Blocks/ReviewsBlock.vue';

export const setup = (app: App<Element>): void => {
    app.component('ReviewsBlock', ReviewsBlock);
};
